import { toTime } from '../../../../../utils/generalHelpers';
import styles from './style.module.scss';
import Webcam from 'react-webcam';
import { RefObject } from 'react';

interface Props {
    counter: number;
    showMore: boolean;
    webcamRef: RefObject<Webcam>;
};

/** The proctoring corner: live camera preview with the time left on the question. */
function ExamStream(props: Props) {
    const { counter, showMore, webcamRef } = props;
    const { hours, minutes, seconds } = toTime(counter);

    return (
        <div className={styles.stream}>
            <div className={styles.stream_video}>
                <Webcam
                    audio
                    muted
                    ref={webcamRef}
                />
            </div>
            <div className={styles.stream_detail} data-show-more={showMore}>
                <span className={styles.stream_detail_live} />
                <span className={styles.stream_detail_countdown}>
                    {`${hours}:${minutes}:${seconds}`}
                </span>
            </div>
        </div>
    )
};

export default ExamStream;
